import { createUUID } from "@/shared/utils/utils";

interface IBackendReferencingComponents {
  id: string;
  grouping_id: string;
  
  source_datamodel_id: string;
  source_type: string;
  target_datamodel_id: string;
  target_type: string;
  source_field_id: string;
  target_field_id: string;
}

interface IFrontendReferencingComponent {
 id: string;
  grouping_id: string;
  
  source_datamodel_id: string;
  source_type: string;
  
  target_datamodel_id: string;
  target_type: string;

  relations: {
    source_field_id: string;
    target_field_id: string;
  } [];
}

export function transformToBackendReferencingComponents(
  data: IFrontendReferencingComponent[]
): { components: IBackendReferencingComponents[] } {
  const referencingComponents = []
  for (const referencingComponent of data) {
    for (const relation of referencingComponent.relations) {
      referencingComponents.push({
        id: createUUID(),
        grouping_id: referencingComponent.grouping_id,

        source_datamodel_id: referencingComponent.source_datamodel_id,
        source_type: referencingComponent.source_type,
        source_field_id: relation.source_field_id,

        target_datamodel_id: referencingComponent.target_datamodel_id,
        target_type: referencingComponent.target_type,
        target_field_id: relation.target_field_id
      });
    }
  }
  return {
    components: referencingComponents
  }
}

export function transformFromBackendReferencingComponents(
  backendData: IBackendReferencingComponents[]
): IFrontendReferencingComponent[] {
  const frontendComponentsMap: { [key: string]: IFrontendReferencingComponent } = {};

  for (const backendComponent of backendData) {
    if (!frontendComponentsMap[backendComponent.grouping_id]) {
      frontendComponentsMap[backendComponent.grouping_id] = {
        id: backendComponent.id,
        grouping_id: backendComponent.grouping_id,
        source_datamodel_id: backendComponent.source_datamodel_id,
        source_type: backendComponent.source_type,
        target_datamodel_id: backendComponent.target_datamodel_id,
        target_type: backendComponent.target_type,
        relations: []
      };
    }
    frontendComponentsMap[backendComponent.grouping_id].relations.push({
      source_field_id: backendComponent.source_field_id,
      target_field_id: backendComponent.target_field_id
    });
  }

  return Object.values(frontendComponentsMap);
}